module.exports = __webpack_public_path__ + "static/img/max_pictgrid27_980x858.5e63385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid27_980x858.jpg
// module id = PFuS
// module chunks = 0